import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { WorkGallery } from '../components/WorkGallery';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <div className="min-h-screen bg-background text-white font-sans selection:bg-primary/30 selection:text-white" data-id="element-287">
      <Hero data-id="element-288" />
      <ProblemSection data-id="element-289" />
      <WorkGallery data-id="element-290" />
      <Features data-id="element-291" />
      <Pricing data-id="element-292" />
      <Testimonials data-id="element-293" />
      <FAQ data-id="element-294" />
      <Footer data-id="element-295" />
      <WhatsAppButton data-id="element-296" />
    </div>;
}